import gerenciamento from './gerenciamento'
import parametrizacao from './parametrizacao'
import ralatorioSolicitacoes from './relatorioSolicitacoes'
import solicitacao from './solicitacao'

export default [
    {
        path: 'manutencao',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...gerenciamento,
            ...parametrizacao,
            ...ralatorioSolicitacoes,
            ...solicitacao,
        ]
    }
]